import { useContext } from 'react';
import { PageContext } from './PageContext';
import type { PageContextType } from './PageContext';

export const usePageContext = () => {
  const context = useContext<PageContextType | undefined>(PageContext);
  if (!context) {
    throw new Error('usePage must be used within a PageProvider');
  }
  return context;
};
